// extracted by mini-css-extract-plugin
export var aboveInput = "_g2-0";
export var actionButton = "_g2-5";
export var actionButtonContainer = "_g2-1";
export var actionIcon = "_g2-6";
export var aiInfoContainer = "_g2-2";
export var attachmentWrapper = "_g2-7";
export var bold = "_g2-3";
export var checkIcon = "_g2-8";
export var clickingRecipientBar = "_g2-11";
export var commentThreadSwitch = "_g2-a";
export var draftImage = "_g2-b";
export var draftImageContainer = "_g2-c";
export var draftImages = "_g2-e";
export var editButton = "_g2-g";
export var editor = "_g2-f";
export var editorContainer = "_g2-y";
export var editorErrorTooltipWrapper = "_g2-9";
export var headerDivider = "_g2-h";
export var icon = "_g2-i";
export var info = "_g2-j";
export var internal = "_g2-n";
export var internalDivider = "_g2-k";
export var internalMessage = "_g2-l";
export var messageInputCard = "_g2-m";
export var messageInputForm = "_g2-o";
export var messageInputFormInternal = "_g2-p";
export var options = "_g2-q";
export var publicMessageCustomer = "_g2-s";
export var publicMessageMerchant = "_g2-r";
export var removeImageButton = "_g2-d";
export var replyButtons = "_g2-t";
export var showSignatureButton = "_g2-u";
export var spinner = "_g2-v";
export var verticalButtonDivider = "_g2-4";
export var visibilitySelector = "_g2-w";
export var warning = "_g2-x";
export var wrappingText = "_g2-z";
export var writingInternalNoteTopBorder = "_g2-10";